import React, { useEffect } from "react";
import { Button } from "semantic-ui-react";
// import { KButton } from '@klearnow/design-system';
// import '@klearnow/design-system/dist/design-system.cjs.development.css';
import { startJob, startBhHouseJob, sendMsgToRocketChat, updateWorkFlow } from "../../commonApis"

const StartJobButton = (props) => {
    const declarationEntryType = props.EUData?.declarationEntryType;
    const transmissionType = props.EUData?.transmissionType;
    const START_JOB = props.EUData?.START_JOB;

    useEffect(() => {
        let dectype = declarationEntryType;
        if (START_JOB) {
            if (transmissionType === "PDI") {
                dectype = "PDI"
            }
            if (transmissionType === "BOX 40") {
                dectype = "BOX40"
            }
            if (transmissionType === "BOX 44") {
                dectype = "BOX44"
            }
            if (dectype === "ExportTypeA") {
                dectype = "TYPE_A"
            }
            if (dectype === "ExportTypeB") {
                dectype = "TYPE_B"
            }
            if (dectype === "ExportTypeC") {
                dectype = "TYPE_C"
            }
            if (dectype === "ExportTypeX") {
                dectype = "TYPE_X"
            }
            if (dectype === "ExportTypeY") {
                dectype = "TYPE_Y"
            }
            if (props.EntryState === "STATE_ENTRY_NONE") {
                startJobFirstTimeClickHandler(dectype);
            } else {
                startJobClickHandler(dectype, transmissionType)
            }
        }
    }, [declarationEntryType, transmissionType])

    const startJobClickHandler = async (type, transmissionType) => {
        let brokerUserGuid = props.kxUser.userBasicInfo.userGuid;
        if (["BOX40", "BOX44"].includes(type)) {
            await updateWorkFlow(props.shipId, "ENTRY_IN_PROCESS", brokerUserGuid).then(() => {
                //props.searchByID(props.shipId)
                document.getElementById(`card-${shipId}`).click();
            })
            return;
        }
        if (!type) {
            startJobFirstTimeClickHandler();
        }

        if ((type === 'FULL_SAD' || type === 'PDC') && props.EntryState === 'STATE_ENTRY_ACCEPTED' && transmissionType === "NEW") {
            updateWorkFlow(props.shipId, 'ENTRY_IN_PROCESS', brokerUserGuid)
        }
        if (transmissionType === "MOD") {
            await updateWorkFlow(props.shipId, "ENTRY_AMEND_IN_PROCESS", brokerUserGuid).then(() => {
                props.searchByID(props.shipId)
            })
        }
        let eventType = type + "_NEW";

        if (transmissionType === "MOD") {
            eventType = type + "_AMEND_NEW";

            if (type === "TYPE_A") {
                type = "ExportAmendTypeA"
            }
            else if (type === "TYPE_B") {
                type = "ExportAmendTypeB"
            }
            else if (type === "TYPE_C") {
                type = "ExportAmendTypeC"
            }
            else if (type === "PDI") {
                type = "PdiAmend"
            }
            else {
                type = "PdcAmend"
            }
        }
        if (!type) {
            eventType = "ENTRY_IN_PROCESS"
        }
        await startJob(props.shipId, type, eventType, brokerUserGuid).then(() => {
            props.searchByID(props.shipId)
            props.setEUData({
                START_JOB: false,
            })
            // setTimeout(()=>{
            //     document.getElementById(`card-${props.shipId}`).click();
            // },2000);
        })
    }

    const startJobFirstTimeClickHandler = (type) => {
        let brokerUserGuid = props.kxUser.userBasicInfo.userGuid;
        startBhHouseJob(props.shipId, "BH_BROKER_ASSIGNED", brokerUserGuid).then(async (res) => {
            startBhHouseJob(props.shipId, "BH_BROKER_IN_PROCESS", brokerUserGuid).then(async (res) => {
                sendMsgToRocketChat(props.shipId, 13, brokerUserGuid);

                let eventType = type ? type + "_NEW" : "ENTRY_IN_PROCESS";
                if (type) {
                    startJob(props.shipId, type, eventType, brokerUserGuid).then(() => {
                        props.searchByID(props.shipId)
                        props.setEUData({
                            START_JOB: false,
                        })
                    })
                }
            })
        })
    }

    let stateInProcess = (props.EntryState.includes('NONE') || props.EntryState.includes('IN_PROCESS') || props.EntryState.includes('READY'));
    return (
        <>
            {
                stateInProcess &&
                <Button
                    size="mini"
                    key="START_JOB_EU"
                    disabled={false}
                    style={{ "display": props.display }}
                    className="sv todo-button primaryBtn"
                    onClick={(e) => {
                        e.stopPropagation();
                        startJobClickHandler(declarationEntryType);
                    }}
                >
                    {`START ${declarationEntryType || "JOB"}`}
                </Button>
            }
        </>

    );
}

export default StartJobButton;
